import { Button, type ButtonProps } from '@nrg/design-system';

export type AuthFooterLinkProps = Omit<ButtonProps, 'variant' | 'size'>;

export default function AuthFooterLink({ type = 'button', ...props }: AuthFooterLinkProps) {
  return <Button variant="ghost" size="sm" type={type} {...props} />;
}
